import { cookieManager } from "@/_old/utils/cookie-manager";

export const getRefreshToken = () => {
  const result = cookieManager.get<string>({
    cookieName: "u_refresh_token",
  });

  if (result === "undefined") {
    return undefined;
  }

  return result;
};

export const getAccessToken = () => {
  const result = cookieManager.get<string>({
    cookieName: "u_token",
  });

  if (result === "undefined") {
    return undefined;
  }

  return result;
};

const getExpirationCookie = () => {
  const actualDate = new Date();

  return new Date(new Date(actualDate).setMonth(actualDate.getMonth() + 1));
};

const setAccessToken = (token: string) => {
  const expirationDate = getExpirationCookie();

  cookieManager.set({
    cookieName: "u_token",
    value: token,
    globally: true,
    expirationDate,
    path: "/",
  });
};

const setRefreshToken = (refreshToken: string) => {
  const expirationDate = getExpirationCookie();

  cookieManager.set({
    cookieName: "u_refresh_token",
    value: refreshToken,
    globally: true,
    expirationDate,
    path: "/",
  });
};

const removeAccessToken = () => {
  cookieManager.remove({ cookieName: "u_token", globally: true });
};

const removeRefreshToken = () => {
  cookieManager.remove({ cookieName: "u_refresh_token", globally: true });
};

/**
 * Removes the legacy last_url_path cookie.
 * This function is kept for backward compatibility to clean up old cookies
 * that may still exist in users' browsers after migration to query params.
 * @deprecated Migration to query params completed - this is only for cleanup
 */
export const removeLastUrlPath = () => {
  cookieManager.remove({ cookieName: "last_url_path", globally: true });
};

export const removeAllTokens = () => {
  removeAccessToken();
  removeRefreshToken();

  const paths = [
    "/company/members",
    "/insights",
    "/packages",
    "/painel",
    "/painel-novo",
  ];

  paths.forEach((path) => {
    cookieManager.remove({
      cookieName: "u_token",
      globally: true,
      path,
    });

    cookieManager.remove({
      cookieName: "u_refresh_token",
      globally: true,
      path,
    });
  });
};

export const updateUserToken = (
  newAccessToken: string,
  newRefreshToken: string,
) => {
  setAccessToken(newAccessToken);
  setRefreshToken(newRefreshToken);
};
